export default __webpack_public_path__ + "static/media/numOfResource.56f042d1.svg";